module.exports = __webpack_public_path__ + "img/lootbox_progress_bar.9d7e8f5e.png";